export const TOOLTIP_DEFAULT_TEXT_ALIGN = 'center';
export const TOOLTIP_DEFAULT_DISTANCE = 12;
export const TOOLTIP_DEFAULT_VISIBLE = false;
export const TOOLTIP_TEXT_ALIGN_DICT = {
    left: 'tooltip__left',
    right: 'tooltip__right',
    center: 'tooltip__center'
};
//# sourceMappingURL=Tooltip.constants.js.map